import { connect } from 'react-redux';
import classnames from 'classnames';

import { UPLOAD_FLEXI_LOAN_DOCUMENT_REQUIREMENT } from '../../../ApplyFlexiLoanView.actions';

import { ArrowRightSVG } from '@svgComponents/arrowRightSVG';
import { CircleSVG } from '@svgComponents/CircleSVG';
import { TickCircleSVG } from '@svgComponents/tickCircleSVG';
import { FailedSVG } from '@svgComponents/failedSVG/index';

import pendingStyles from '../../../../pageStructure/mainContentPending/MainContentPending.module.css';
import styles from '../documentRequirements/DocumentRequirements.module.css';
import LatestBankStatements from '../latestBankStatements/LatestBankStatements';
import { Dispatch } from 'redux';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    uploadDocumentRequirement: (documentType: string) =>
        dispatch({
            type: UPLOAD_FLEXI_LOAN_DOCUMENT_REQUIREMENT,
            documentType
        })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const DocumentRequirementsSectionWithoutConnect = ({
    documentRequirements,
    uploadDocumentRequirement,
    isLoading,
    hasSubmitFailed
}: PropsFromRedux & {
    isLoading: boolean;
    hasSubmitFailed: boolean;
    documentRequirements: any;
}) => {
    if (isLoading) {
        return (
            <div className={styles.documentRequirement}>
                <div className={pendingStyles.pendingItem} />
            </div>
        );
    }

    return documentRequirements.map(
        ({ status, type, hasItems, hasError, uploadModalDocType }: any) => {
            if (
                type === 'kontoauszuege_hochladen' //bank_statement
            ) {
                return (
                    <LatestBankStatements
                        key={type}
                        hasSubmitFailed={hasSubmitFailed}
                    />
                );
            }

            return (
                <div
                    className={styles.documentRequirement}
                    onClick={() =>
                        uploadDocumentRequirement(uploadModalDocType)
                    }
                    data-testid={`${type}-requirement`}
                    key={type}
                    role="button"
                >
                    <DocumentStatusIndicator
                        status={status}
                        hasItems={hasItems}
                        hasError={hasError}
                    />

                    <div className={styles.contentWrapper}>
                        <span className={styles.documentLabel}>
                            <DocumentRequirementLabel type={type} />
                        </span>
                    </div>

                    <ArrowRightSVG className={styles.documentArrow} />

                    {status !== 'pending' &&
                        status !== 'completed' &&
                        hasSubmitFailed && (
                            <div
                                data-testid="formErrors"
                                className={styles.error}
                            >
                                <span>
                                    Bitte laden Sie Ihre Unterlagen hoch
                                </span>
                            </div>
                        )}
                </div>
            );
        }
    );
};

const DocumentRequirementLabel = ({ type }: { type: string }) => {
    switch (type) {
        case 'kontoauszuege_hochladen':
            return (
                <>
                    Kontoauszüge{' '}
                    <span className={styles.documentLabelCaption}>
                        der letzten 90 Tage im pdf-Format
                    </span>
                </>
            );
        case 'bwa_hochladen':
            return (
                <>
                    Betriebswirtschaftliche Auswertung (oder Gewinn und
                    Verlustrechnung / Einnahmenüberschussrechnung)
                </>
            );
        case 'jaehrliche_bwa_susa_hochladen':
            return (
                <>
                    Betriebswirtschaftliche Auswertung inkl. Summen- und
                    Saldenliste (oder Jahresabschluss){' '}
                    <span className={styles.documentLabelCaption}>
                        der letzten beiden Geschäftsjahre
                    </span>
                </>
            );
        case 'bwa_susa_hochladen':
            return (
                <>
                    Aktuelle betriebswirtschaftliche Auswertung inkl. Summen-und
                    Saldenliste{' '}
                    <span className={styles.documentLabelCaption}>
                        nicht älter als 4 Monate
                    </span>
                </>
            );
        default:
            return null;
    }
};

const DocumentStatusIndicator = ({
    status,
    hasItems,
    hasError
}: {
    status: string;
    hasItems: boolean;
    hasError: boolean;
}) => {
    if (hasError)
        return (
            <FailedSVG
                className={classnames(styles.statusIcon, styles.failedIcon)}
            />
        );
    if (hasItems || status === 'completed')
        return <TickCircleSVG className={styles.statusIcon} />;

    return <CircleSVG className={styles.statusIcon} />;
};

// eslint-disable-next-line import/no-default-export
export default connect(
    null,
    mapDispatchToProps
)(DocumentRequirementsSectionWithoutConnect);
